import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  selectFormat,
  sortNumeric,
  Error,
  getMetricForColumn,
  TableContentCell,
} from "components/Utils/Utils.js";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";

class LeeTVAdCampaign extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data, cells) {
    const { title, url } = this.props;

    const selected_columns = [];

    data.forEach((d, i) => {
      d.id = i;
      d.image_url = d.ad_image_url;
    });

    const columns = [
      {
        dataField: "ad_image_url",
        text: "Thumbnail",
        style: { width: "90px", minWidth: "90px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        sort: true,
      },
      {
        dataField: "ad_name",
        text: "Ad Name",
        style: { width: "150px", minWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "network",
        text: "Network",
        style: { width: "150px", minWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "campaign",
        text: "Campaign",
        style: { width: "150px", minWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "ad_targeting",
        text: "Targeting",
        style: { width: "150px", minWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "total_spend",
        text: "Spend",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "impressions",
        text: "Impressions",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "clicks",
        text: "Clicks",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "ctr",
        text: "CTR %",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "trials_started",
        text: "Trials Started",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpc",
        text: "CPC",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpa",
        text: "CPA",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "cost_per_install",
        text: "CPA",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    cells.forEach((cell, i) => {
      selected_columns.push(columns.find((o) => o.dataField === cell));
    });

    const pagination = paginationFactory({
      sizePerPage: 20,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField:
          [
            "/dashboard/Leetv/ad-table?p=Leetv&t=pweek&type=facebook_ads",
            "/dashboard/Leetv/ad-table?p=Leetv&type=ad_words&t=pweek",
          ].indexOf(url.toLowerCase()) > -1
            ? "trials_started"
            : "total_spend",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            filter={filterFactory()}
            defaultSorted={defaultSorted}
            footerClasses={"tfoot__tr"}
            pagination={pagination}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, cells } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data, cells);
  }
}

export default LeeTVAdCampaign;
